import React from 'react';
import Table from 'react-bootstrap/Table';
import { HiArrowLongRight } from 'react-icons/hi2';
import { PropTypes } from 'prop-types';
import { formatShortDateWithTimeZone } from '../../../../../utils/dates';
import { getContact } from '../../../../../utils/api/contact';
import { useToasts } from '../../../../../hooks';
import { redirectToContact } from '../../../../../utils/navigation';

const svg = {
  marginLeft: '20px',
  marginRight: '20px',
};

const ACTION_LABELS = {
  added: 'CONTACT ADDED:',
  removed: 'CONTACT REMOVED:',
  primary_contact_set: 'PRIMARY CONTACT SET:',
  primary_contact_removed: 'PRIMARY CONTACT REMOVED:',
  primary_contact_changed: 'PRIMARY CONTACT CHANGED:',
};

const ContactHistoryTable = ({ ContactHistories, organizationId }) => {
  const { showToast } = useToasts();
  const checkContact = (id) => {
    getContact(organizationId, id)
      .then((response) => {
        if (response.status === 200) {
          redirectToContact(id);
        } else if (response.status === 404) {
          showToast({ message: 'This contact has been deleted', type: 'error' });
        }
      })
      .catch((error) => {
        showToast({ message: error, type: 'error' });
      });
  };

  const contactButton = (id, name) => (
    <button
      className="contact-button-link"
      type="button"
      onClick={() => checkContact(id)}
    >{name}
    </button>
  );

  const changeDetails = (contactHistory) => {
    const { action_type: actionType, contact_changes: changes } = contactHistory;
    if (actionType === 'primary_contact_changed') {
      return (
        <>
          {contactButton(changes.old_contact_id, changes.old_contact_name)}
          <HiArrowLongRight style={svg} />
          {contactButton(changes.new_contact_id, changes.new_contact_name)}
        </>
      );
    }
    return contactButton(changes.contact_id, changes.contact_name);
  };

  const columnElements = () => {
    return ContactHistories.map((contactHistory) => {
      return (
        <tr key={contactHistory.id}>
          <td>
            {formatShortDateWithTimeZone(contactHistory.created_at)}
            <div className="date-column-username">
              <p>{contactHistory.user_name}</p>
            </div>
          </td>
          <td>
            <div className="line-of-changes">
              <div className="site-history-update">
                <h6 className="contact-action">{ACTION_LABELS[contactHistory.action_type]}</h6>
                {changeDetails(contactHistory)}
              </div>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <Table striped bordered hover>
      <thead className="site-history-table-head">
        <tr>
          <th className="site-history-table-date-column-header">Date</th>
          <th className="site-history-changes-column-header">Changes</th>
        </tr>
      </thead>
      <tbody>
        {columnElements()}
      </tbody>
    </Table>
  );
};

ContactHistoryTable.propTypes = {
  ContactHistories: PropTypes.array.isRequired,
  organizationId: PropTypes.number.isRequired,
};
export default ContactHistoryTable;
